import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";
import { cx } from "@/utils/cx";

type Tab = {
  id: string;
  label: string;
  disabled?: boolean;
  disabledTooltip?: { title: string; description?: string };
};

type HorizontalTabsProps = {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
};

export const HorizontalTabs = ({ tabs, activeTab, onTabChange, className }: HorizontalTabsProps) => {
  return (
    <div className={cx("bg-primary border border-secondary rounded-[10px] p-1 flex gap-1 w-full", className)}>
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        const isDisabled = tab.disabled === true;

        const button = (
          <button
            key={tab.id}
            type="button"
            aria-disabled={isDisabled || undefined}
            onClick={isDisabled ? undefined : () => onTabChange(tab.id)}
            className={cx(
              "flex-1 h-9 px-3 py-2 rounded-[6px] text-sm font-semibold transition-colors",
              "flex items-center justify-center",
              isDisabled
                ? "bg-transparent text-fg-disabled_subtle cursor-not-allowed"
                : isActive
                  ? "bg-[#181d27] text-white"
                  : "bg-transparent text-quaternary hover:text-tertiary",
            )}
          >
            {tab.label}
          </button>
        );

        if (isDisabled && tab.disabledTooltip) {
          return (
            <Tooltip
              key={tab.id}
              title={tab.disabledTooltip.title}
              description={tab.disabledTooltip.description}
              placement="top"
              arrow
            >
              <TooltipTrigger className="flex-1 inline">{button}</TooltipTrigger>
            </Tooltip>
          );
        }

        return button;
      })}
    </div>
  );
};
